import { useBenefitEnrollment } from "../../context/enrollment/BenefitEnrollmentContext"
import React from "react"
import PropTypes from "prop-types"
import L10n from "lib/carrot-l10n"
import { TextLink } from "../atoms/links/TextLink"
import { ButtonPrimary } from "../atoms/buttons/ButtonPrimary"
const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const Activate = ({ error, onSubmit, submitting }) => {
  const { needsBenefitEnrollment } = useBenefitEnrollment()
  const benefitEnrollmentError = error && needsBenefitEnrollment
  const defaultError = error && !needsBenefitEnrollment

  const needsBenefitEnrollmentErrorMessage = () => {
    return (
      <p className="lh-copy mb0 carrot-red">
        {l`carrotCard.needsEnrollmentActivationError`}
        <TextLink to={"/#needs-benefit-enrollment"}>
          <span>{l`carrotCard.shareAFewDetails`}</span>
        </TextLink>{" "}
        {l`carrotCard.andTryAgain`}
      </p>
    )
  }

  const defaultErrorMessage = () => {
    return (
      <p className="lh-copy mb0 carrot-red">
        {l`carrotCard.defaultActivationError`}
        <TextLink to={"/talk-to-carrot"}>
          <span>{l`carrotCard.contactOurCareTeam`}</span>
        </TextLink>{" "}
        {l`carrotCard.haveQuestions`}
      </p>
    )
  }

  return (
    <div className="pa3-ns pv1">
      <div className="mw6 center pa3-ns pv1">
        <form className="pa4-ns pa3 bg-white" onSubmit={onSubmit}>
          <h1 className="publico-text mt0 mb4 black">{l`carrotCard.activateCarrotCard`}</h1>
          <p className="lh-copy mt0 black-60">{l`carrotCard.activateCardMessage`}</p>
          {defaultError && defaultErrorMessage()}
          {benefitEnrollmentError && needsBenefitEnrollmentErrorMessage()}
          <div className="mt4 flex flex-row justify-end">
            <ButtonPrimary onClick={onSubmit} enabled={!submitting}>
              {submitting ? l`carrotCard.activating` : l`carrotCard.activate`}
            </ButtonPrimary>
          </div>
        </form>
      </div>
    </div>
  )
}

Activate.propTypes = {
  error: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  needsBenefitEnrollment: PropTypes.bool
}

export default Activate
